import React, { useState } from "react";
import { useParams } from "react-router-dom";

import "../styles/General.css";

import Header from "../components/Header";
import TileOverview from "../components/TileOverview";
import TileSavings from "../components/TileSavings";
import TileTopManufacturers from "../components/TileTopManufacturers";
import TileTopDistricts from "../components/TileTopDistricts";
import TileTopLightsources from "../components/TileTopLightsources";
import TileEnergyClassCurrent from "../components/TileEnergyClassCurrent";
import TileEnergyClassPotential from "../components/TileEnergyClassPotential";
import TileTopStreets from "../components/TileTopStreets";

export default function Page() {
  const { id } = useParams();
  const [lightpointsPerYear, setLightpointsPerYear] = useState(1);

  return (
    <div className="page-container">
      {/* Pass id directly to Header */}
      <Header id={id} />

      <div
        style={{
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
          marginBottom: "2rem",
        }}
      >
        <div className="overview-container">
          <h3 className="chart-title">Projektübersicht</h3>
          <TileOverview
            id={id}
            lightpointsPerYear={lightpointsPerYear}
            setLightpointsPerYear={setLightpointsPerYear}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
          marginBottom: "2rem",
        }}
      >
        <div className="chart-container">
          <h3 className="chart-title">Einsparungen / Jahr</h3>
          <TileSavings id={id} lightpointsPerYear={lightpointsPerYear} />
        </div>
        <div className="chart-container">
          <h3 className="chart-title">Top 3 Leuchtenhersteller</h3>
          <TileTopManufacturers id={id} />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
          marginBottom: "2rem",
        }}
      >
        <div className="chart-container">
          <h3 className="chart-title">Leuchtmittel</h3>
          <TileTopLightsources id={id} />
        </div>
        <div className="chart-container">
          <h3 className="chart-title">Top 5 Stadtteile</h3>
          <TileTopDistricts id={id} />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
          marginBottom: "2rem",
        }}
      >
        <div className="chart-container">
          <h3 className="chart-title">Energieeffizienzklassen 2025</h3>
          <TileEnergyClassCurrent id={id} />
        </div>
        <div className="chart-container">
          <h3 className="chart-title">Energieeffizienzklassen Potential</h3>
          <TileEnergyClassPotential id={id} />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
          marginBottom: "2rem",
        }}
      >
        <div className="chart-container">
          <h3 className="chart-title">Straßen nach Leuchtpunkten</h3>
          <TileTopStreets id={id} />
        </div>
      </div>
    </div>
  );
}
